module.exports = __webpack_public_path__ + "img/agix.b89fe90d.svg";